import initNext, * as next from './'

window.next = next

initNext().catch(console.error)
